import { useGetExternalLinks } from "@/api/external-link";
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { ACCORDION_TITLE_CLASS } from "@/lib/accordion-content";

interface ExternalLinksAccordionProps {
  artworkId?: string;
  t: (key: string, options?: any) => string;
}

export function ExternalLinksAccordion({
  artworkId,
  t,
}: ExternalLinksAccordionProps) {
  const { data } = useGetExternalLinks("artwork", artworkId);
  const items = (data ?? []).filter(
    (link) => link?.url && link.url.trim().length > 0,
  );
  if (!artworkId || items.length === 0) return null;

  return (
    <AccordionItem value="external-links">
      <AccordionTrigger className={ACCORDION_TITLE_CLASS}>
        {t("singleArtworkSubtitleExternalLinks")}
      </AccordionTrigger>
      <AccordionContent>
        <ul className="flex list-none flex-col gap-2 pl-0">
          {items.map((link) => {
            const name = link.name?.trim() || link.url;
            const date = link.dateConsultation?.trim();
            const label = date
              ? `${name} (${t("externalLinkDateConsultation")} : ${date})`
              : name;
            return (
              <li key={link.id}>
                <a
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-normal text-sm text-gray-800 hover:text-gray-600"
                >
                  {label}
                </a>
              </li>
            );
          })}
        </ul>
      </AccordionContent>
    </AccordionItem>
  );
}
